import type { RcFile } from 'antd/es/upload';
import Resizer from 'react-image-file-resizer';

export interface ResizeFilePayload {
  compressFormat: 'jpeg' | 'jpg' | 'png';
  maxHeight: number;
  maxWidth: number;
  minHeight?: number;
  minWidth?: number;
  outputType?: 'base64' | 'blob' | 'file';
  quality: number;
  responseUriFunc?: (uri: Blob | File | ProgressEvent<FileReader> | RcFile | string) => void;
  rotation?: number;
}

export const resizeFile = (
  file: File | RcFile,
  {
    compressFormat,
    maxHeight = 300,
    maxWidth = 300,
    minHeight,
    minWidth,
    outputType,
    quality,
    responseUriFunc,
    rotation = 0,
  }: ResizeFilePayload
) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      maxWidth,
      maxHeight,
      compressFormat,
      quality,
      rotation,
      responseUriFunc ??
        ((uri) => {
          resolve(uri);
        }),
      outputType,
      minWidth,
      minHeight
    );
  });
